<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 52.45 44.549"
  >
    <defs>
      <linearGradient id="linear-gradient" x1="0.5" y1="0.201" x2="0.5" y2="1.332" gradientUnits="objectBoundingBox">
        <stop offset="0" stop-color="#de4551" stop-opacity="0" />
        <stop offset="1" stop-color="#de4551" />
      </linearGradient>
      <linearGradient id="linear-gradient-2" y1="0" y2="1" xlink:href="#linear-gradient" />
    </defs>
    <g id="Group_178" data-name="Group 178" transform="translate(0 -38.56)">
      <path
        id="Path_703"
        data-name="Path 703"
        d="M48.3,50.945c-6.7-5.152-13.2-.953-20.451-2.438-7.3-1.5-10.212-6.474-18.529-4.176C1.95,46.367-2.52,54.529,1.53,61.363c1.154,1.947,3.12,3.416,3.924,5.6,1.3,3.515-.677,6.213-.292,9.668,1.6,14.352,23.518,8.793,31.583,4.328C49.393,73.95,57.95,58.365,48.3,50.945Z"
        transform="translate(0 -4.644)"
        fill="url(#linear-gradient)"
      />
      <g id="Group_112" data-name="Group 112" transform="translate(7.02 38.56)">
        <path
          id="Path_704"
          data-name="Path 704"
          d="M115.506,88.319l-3.466-3.068h0l-9.376-3.3,2.712-3.034a1.024,1.024,0,0,0-.764-1.707h-3.654V69.584a1.024,1.024,0,0,0-1.024-1.024H95.267a1.024,1.024,0,0,0-1.024,1.024v7.626H90.589a1.024,1.024,0,0,0-.764,1.707l2.712,3.034-9.376,3.3h0l-3.466,3.068a.512.512,0,0,0,.17.867l3.3,1.16v13.947a1.024,1.024,0,0,0,.684.966l13.416,4.72a1.024,1.024,0,0,0,.68,0l13.416-4.72a1.024,1.024,0,0,0,.684-.966V90.345l3.3-1.16a.512.512,0,0,0,.17-.867Z"
          transform="translate(-78.395 -65.487)"
          opacity="0.1"
          fill="url(#linear-gradient-2)"
          style="isolation: isolate"
        />
        <g id="Group_110" data-name="Group 110" transform="translate(0.614 0)">
          <g id="Group_107" data-name="Group 107" transform="translate(4.151 0.512)">
            <g id="Group_100" data-name="Group 100" transform="translate(0 11.61)">
              <path
                id="Path_705"
                data-name="Path 705"
                d="M143.92,206.49v19.041a1.024,1.024,0,0,1-.684.966l-13.756,4.839L115.724,226.5a1.024,1.024,0,0,1-.684-.966V206.49Z"
                transform="translate(-115.04 -201.41)"
                fill="#fff"
              />
              <path
                id="Path_706"
                data-name="Path 706"
                d="M270.44,206.49v19.041a1.024,1.024,0,0,1-.684.966L256,231.337V206.49Z"
                transform="translate(-241.56 -201.41)"
                fill="#fff"
              />
              <g id="Group_99" data-name="Group 99" transform="translate(0.001)">
                <path
                  id="Path_707"
                  data-name="Path 707"
                  d="M129.485,156.9l-14.44,5.08,14.44,5.08,14.44-5.08Z"
                  transform="translate(-115.045 -156.898)"
                  fill="#f0324c"
                />
              </g>
            </g>
            <path
              id="Path_708"
              data-name="Path 708"
              d="M177.8,53.918l7.011,7.845a1.024,1.024,0,0,0,1.528,0l7.011-7.845a1.024,1.024,0,0,0-.764-1.707h-3.654V44.584a1.024,1.024,0,0,0-1.024-1.024h-4.666a1.024,1.024,0,0,0-1.024,1.024v7.626h-3.654a1.024,1.024,0,0,0-.764,1.707Z"
              transform="translate(-171.137 -43.56)"
              fill="#fff"
            />
            <g id="Group_101" data-name="Group 101" transform="translate(21.908 28.383)">
              <path
                id="Path_709"
                data-name="Path 709"
                d="M328.9,322.527v1.489a.512.512,0,0,0,.681.484l3.981-1.387a.512.512,0,0,0,.344-.484V321.14a.512.512,0,0,0-.681-.484l-3.981,1.387a.512.512,0,0,0-.344.484Z"
                transform="translate(-328.902 -320.628)"
                fill="#f0324c"
              />
              <path
                id="Path_710"
                data-name="Path 710"
                d="M328.9,356.766v1.489a.512.512,0,0,0,.681.484l3.981-1.387a.512.512,0,0,0,.344-.484v-1.489a.512.512,0,0,0-.681-.484l-3.981,1.387a.512.512,0,0,0-.344.484Z"
                transform="translate(-328.902 -351.359)"
                fill="#f0324c"
              />
            </g>
            <g id="Group_104" data-name="Group 104" transform="translate(1.829 28.381)">
              <g id="Group_102" data-name="Group 102">
                <path
                  id="Path_711"
                  data-name="Path 711"
                  d="M135.751,322.433a.508.508,0,0,1-.165-.028l-2.347-.8a.512.512,0,0,1,.331-.969l2.347.8a.512.512,0,0,1-.166,1Z"
                  transform="translate(-132.892 -320.607)"
                  fill="#2f3042"
                />
              </g>
              <g id="Group_103" data-name="Group 103" transform="translate(0 1.883)">
                <path
                  id="Path_712"
                  data-name="Path 712"
                  d="M135.751,340.814a.507.507,0,0,1-.165-.028l-2.347-.8a.512.512,0,0,1,.331-.969l2.347.8a.512.512,0,0,1-.166,1Z"
                  transform="translate(-132.892 -338.988)"
                  fill="#2f3042"
                />
              </g>
            </g>
            <g id="Group_106" data-name="Group 106" transform="translate(1.829 26.138)">
              <g id="Group_105" data-name="Group 105">
                <path
                  id="Path_713"
                  data-name="Path 713"
                  d="M139.406,301.787a.508.508,0,0,1-.165-.028l-6-2.049a.512.512,0,0,1,.331-.969l6,2.049a.512.512,0,0,1-.166,1Z"
                  transform="translate(-132.892 -298.714)"
                  fill="#2f3042"
                />
              </g>
            </g>
          </g>
          <g id="Group_108" data-name="Group 108" transform="translate(18.591 17.203)">
            <path
              id="Path_714"
              data-name="Path 714"
              d="M270.44,206.488l3.466,3.068a.512.512,0,0,1-.17.867L260.4,215.114a.512.512,0,0,1-.51-.1L256,211.568Z"
              transform="translate(-256 -206.488)"
              fill="#fff"
            />
          </g>
          <g id="Group_109" data-name="Group 109" transform="translate(0.513 17.203)">
            <path
              id="Path_715"
              data-name="Path 715"
              d="M83.161,206.488,79.7,209.556a.512.512,0,0,0,.17.867L93.2,215.114a.512.512,0,0,0,.509-.1l3.893-3.446Z"
              transform="translate(-79.523 -206.488)"
              fill="#fff"
            />
          </g>
          <path
            id="Path_716"
            data-name="Path 716"
            d="M111.356,58.447l-3.466-3.068a.586.586,0,0,0-.17-.1l-8.654-3.045,2.2-2.463a1.537,1.537,0,0,0-1.146-2.561H96.98V40.1a1.538,1.538,0,0,0-1.537-1.537H90.778A1.538,1.538,0,0,0,89.241,40.1v7.114H86.1a1.537,1.537,0,0,0-1.146,2.561l7.011,7.845a1.537,1.537,0,0,0,2.292,0l4.071-4.555,7.679,2.7L93.111,60.3l-12.9-4.537,4.875-1.715a.512.512,0,1,0-.34-.966l-6.248,2.2a.583.583,0,0,0-.17.1l-3.466,3.068a1.024,1.024,0,0,0,.339,1.733l2.954,1.039V74.8a1.538,1.538,0,0,0,1.027,1.449l13.755,4.839a.513.513,0,0,0,.34,0l13.755-4.839a1.539,1.539,0,0,0,1.027-1.449V63.736a.512.512,0,1,0-1.024,0V74.8a.513.513,0,0,1-.342.483L93.111,80.067,79.525,75.287a.513.513,0,0,1-.342-.483V61.581l9.355,3.291a1.025,1.025,0,0,0,1.019-.2l3.554-3.146,3.553,3.146a1.025,1.025,0,0,0,1.019.2l13.334-4.691a1.025,1.025,0,0,0,.339-1.734ZM93.492,56.933a.512.512,0,0,1-.764,0l-7.011-7.845h0a.512.512,0,0,1,.382-.854h3.654a.512.512,0,0,0,.512-.512V40.1a.513.513,0,0,1,.512-.512h4.666a.513.513,0,0,1,.512.512v7.626a.512.512,0,0,0,.512.512h3.654a.512.512,0,0,1,.382.854Zm-4.614,6.972L75.544,59.215l3.241-2.869,3.874,1.363,9.459,3.328Zm8.465,0L94.1,61.037l13.334-4.691,3.241,2.869Z"
            transform="translate(-74.52 -38.56)"
            fill="#2f3042"
          />
        </g>
        <g id="Group_111" data-name="Group 111" transform="translate(0 0.448)">
          <path
            id="Path_717"
            data-name="Path 717"
            d="M170.77,44.933a.51.51,0,0,1-.362-.15l-.611-.611-.611.611a.512.512,0,0,1-.724-.724l.973-.973a.512.512,0,0,1,.724,0l.973.973a.512.512,0,0,1-.362.874Z"
            transform="translate(-158.089 -42.935)"
            fill="#f0324c"
          />
          <path
            id="Path_718"
            data-name="Path 718"
            d="M70.985,417.057a.51.51,0,0,1-.362-.15l-.611-.611-.611.611a.512.512,0,0,1-.724-.724l.973-.973a.512.512,0,0,1,.724,0l.973.973a.512.512,0,0,1-.362.874Z"
            transform="translate(-68.526 -376.939)"
            fill="#f0324c"
          />
          <path
            id="Path_719"
            data-name="Path 719"
            d="M409.97,164.784a1.485,1.485,0,1,1,1.05-.434A1.48,1.48,0,0,1,409.97,164.784Zm0-1.946a.461.461,0,1,0,.326.135A.46.46,0,0,0,409.97,162.838Z"
            transform="translate(-373.66 -149.636)"
            fill="#f0324c"
          />
          <path
            id="Path_720"
            data-name="Path 720"
            d="M111.531,438.363a1.485,1.485,0,1,1,1.05-.434A1.481,1.481,0,0,1,111.531,438.363Zm0-1.946a.461.461,0,1,0,.326.135A.46.46,0,0,0,111.531,436.417Z"
            transform="translate(-105.793 -395.19)"
            fill="#f0324c"
          />
          <path
            id="Path_721"
            data-name="Path 721"
            d="M306.393,79.76a1.485,1.485,0,1,1,1.05-.434A1.48,1.48,0,0,1,306.393,79.76Zm0-1.945a.461.461,0,1,0,.326.135A.46.46,0,0,0,306.393,77.814Z"
            transform="translate(-280.693 -73.322)"
            fill="#f0324c"
          />
        </g>
      </g>
      <path
        id="Path_722"
        data-name="Path 722"
        d="M251,257.973h1.024v19.573H251Z"
        transform="translate(-225.287 -196.936)"
        fill="#2f3042"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-12'
    },
    height: {
      type: String,
      default: 'h-12'
    }
  }
}
</script>
